import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import moment from 'moment';
import ExcelReader from 'components/common/FileController/ExcelReader';
import CenterOptionList from 'components/common/CommonComponent/CenterOptionList';
import { ConfigProvider, Table, DatePicker, Button } from 'antd';
import { text_companyNm } from 'lib/textChang';

import koKr from 'antd/es/locale/ko_KR';
import 'moment/locale/ko';
import './StatsView.scss';
moment.locale('ko');

@inject('statsStore')
@observer
class StatsView extends Component {

  onSearch = () => {
    this.props.statsStore.disStatsGoods(null);
  };

  formattedNumber = (item) => {
    var value = item || 0;
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  }

  render() {
    const {
      valCondition,
      onChangValue,

      statsGoods,

      disStatsGoods,
    } = this.props.statsStore;
    
    const columnsGoods = [
      { title: '품 목',  dataIndex: 'gdNm', width: 150, align: 'center' },
      { title: '단 가',  dataIndex: 'gdPrice', width: 100, align: 'right',
        render: (item) => this.formattedNumber(item) },
      { title: '현 재고',  dataIndex: 'stCnt', width: 100, align: 'right' },
      { title: valCondition?.orBranchNm + text_companyNm() +' 주문수량',  
        dataIndex: 'totalCntBranch', width: 200, align: 'right',
        render: (item) => this.formattedNumber(item) },
      { title: '총 주문수량',  dataIndex: 'totalCnt', width: 100, align: 'right',
        render: (item) => this.formattedNumber(item) },  
      { title: '금 액 (VAT포함)',  dataIndex: 'totalPrice', width: 100, align: 'right',
        render: (item) => this.formattedNumber(item) },
    ];

    return (
      <Fragment>
        <div className="search-box mo_srch_box">
          <div className="search-content" style={{float:'left'}}>
            <span className="mo_srch">
              <span className="labal2">통계 기간</span> 
              <ConfigProvider locale={koKr}>
                <DatePicker
                  style={{ width: 150, marginRight: '20px' }}
                  picker="month"
                  format={'YYYY-MM'}
                  allowClear={false}
                  defaultValue={moment(moment().format('YYYY-MM'), 'YYYY-MM-DD')}
                  onChange={(date)=>{
                    onChangValue('date', moment(date).format('YYYY-MM'));
                    this.onSearch();
                  }}
                />
              </ConfigProvider>
            </span>
          </div>
          <div className="search-content" style={{float:'left'}}>
            <span className="mo_srch">
              <span className="labal2">{text_companyNm()}</span> 
              <CenterOptionList
                style={{ width: 250, marginRight: '20px' }}
                allText={"전체"}
                onlyBranchCd={true}
                ceBranchCdValue={valCondition.orBranchCd}
                eBranchCdChange={(value, option)=>{
                  // console.log(option?.children)
                  onChangValue('orBranchNm', option?.children || '');
                  disStatsGoods(valCondition.gdCd, value);
                }}
              />
            </span>
          </div>
          <div className="search-button">
            <Button type="primary" onClick={this.onSearch}>조회</Button>
          </div>
        </div>
        <div className="button-group">
          <div className="button-right">
            <ul>
              <li>
                {/* 상품별 엑셀다운로드 */}
                <ExcelReader
                  actionType={'download'}
                  pageUrl={'DOWN-STATS-GOODS'}
                  schInfo={valCondition}
                />
              </li>
            </ul>
          </div>
        </div>
        <div className="table-border_st_b">
        <Table
          bordered
          rowKey={(record)=>record.stGdCd}
          columns={columnsGoods}
          dataSource={statsGoods}
          pagination={false}
          //footer={() => 'Footer'}
          summary={(pageData) => {
            let sumStCnt = 0, sumTotalCntBranch = 0, sumTotalCnt = 0, sumTotalPrice = 0;
            pageData.forEach(({ stCnt, totalCntBranch, totalCnt, totalPrice }) => {
              sumStCnt += stCnt;
              sumTotalCntBranch += totalCntBranch;
              sumTotalCnt += totalCnt;
              sumTotalPrice += totalPrice;

            });
            const tdStyle = {
              textAlign: 'right',
              fontWeight: 'bold'
            };
            return (
              <Fragment>
                <tr style={{backgroundColor: '#fafafa'}}>
                  <td style={{...tdStyle, textAlign: 'center'}} colSpan={2}>합 계</td>
                  <td style={tdStyle}>{this.formattedNumber(sumStCnt)}</td>
                  <td style={tdStyle}>{this.formattedNumber(sumTotalCntBranch)}</td>
                  <td style={tdStyle}>{this.formattedNumber(sumTotalCnt)}</td>
                  <td style={tdStyle}>{this.formattedNumber(sumTotalPrice)}</td>
                </tr>
              </Fragment>
            );
          }}
        />
        {/* {(statsGoods.length > 0) &&
          <table className="st_b">
            <colgroup>
              <col style={{width: '100px', minWidth:'100px'}}/>
              <col style={{width: '100px', minWidth:'100px'}}/>
              <col style={{width: '100px', minWidth:'100px'}}/>
              <col style={{width: '100px', minWidth:'100px'}}/>
              <col style={{width: '100px', minWidth:'100px'}}/>
              <col style={{width: '100px', minWidth:'100px'}}/>
              <col style={{width: '100px', minWidth:'100px'}}/>
              <col style={{width: '100px', minWidth:'100px'}}/>
            </colgroup>
            <tbody>
              <tr>
                <td className="b_02"></td>
                <td className="b_04"></td>
                <td className="b_03"></td>
                <td className="b_02"></td>
                <td className="b_03"></td>
                <td className="b_02"></td>
                <td className="b_03"></td>
                <td className="b_01"></td>
              </tr>
            </tbody>
          </table>
        } */}
        </div>
      </Fragment>
    );
  }

}

export default withRouter(StatsView);
